module.exports = __webpack_public_path__ + "static/media/ToyotaDisplay-Regular.b124e922.otf";